export const getModuleOptionsInterface = () => ({
  hookCardListUpdated: () => {},
})
